<script>
import { mapGetters } from 'vuex';
import DatePicker from 'dashboard/components/ui/DatePicker/DatePicker.vue';
// import { useAlert } from 'dashboard/composables';

export default {
  components: {
    DatePicker,
  },
  props: {
    filtersBeingEdited: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      dateRange: [],
      selectedStatusFilter: [],
      selectedOrganicOrRecurringFilter: 'organic',
    };
  },
  computed: {
    ...mapGetters({
      conversation: 'getSelectedChat',
      accountId: 'getCurrentAccountId',
      globalConfig: 'globalConfig/get',
    }),

    filterStatusList() {
      return [
        {
          id: 'active',
          label: this.$t('CAMPAIGN.FILTER.STATUS.ACTIVE'),
          selected: true,
        },
        {
          id: 'processing',
          label: this.$t('CAMPAIGN.FILTER.STATUS.PROCESSING'),
          selected: true,
        },
        {
          id: 'in_progress',
          label: this.$t('CAMPAIGN.FILTER.STATUS.IN_PROGRESS'),
          selected: true,
        },
        {
          id: 'completed',
          label: this.$t('CAMPAIGN.FILTER.STATUS.COMPLETED'),
          selected: true,
        },
        {
          id: 'error',
          label: this.$t('CAMPAIGN.FILTER.STATUS.ERROR'),
          selected: true,
        },
        {
          id: 'aborted',
          label: this.$t('CAMPAIGN.FILTER.STATUS.ABORTED'),
          selected: true,
        },
      ];
    },
    filterOrganicOrRecurringList() {
      return [
        {
          id: 'organic',
          label: this.$t('CAMPAIGN.FILTER.ORIGIN.ORGANIC'),
        },
        {
          id: 'recurring',
          label: this.$t('CAMPAIGN.FILTER.ORIGIN.RECURRING'),
        },
        {
          id: 'all',
          label: this.$t('CAMPAIGN.FILTER.ORIGIN.ALL'),
        },
      ];
    },
  },
  mounted() {
    this.setInitialFilters();
  },
  methods: {
    setInitialFilters() {
      const {
        selectedStatusFilter,
        selectedOrganicOrRecurringFilter,
        dateRange,
      } = this.filtersBeingEdited;

      this.selectedStatusFilter = selectedStatusFilter || this.filterStatusList;
      this.selectedOrganicOrRecurringFilter =
        this.filterOrganicOrRecurringList.find(
          r => r.id === selectedOrganicOrRecurringFilter
        ) || this.filterOrganicOrRecurringList[0];
      this.dateRange = dateRange || [];
    },
    editCurrentFilter() {
      const filterSettings = {
        selectedOrganicOrRecurringFilter:
          this.selectedOrganicOrRecurringFilter.id,
        selectedStatusFilter: this.selectedStatusFilter,
        dateRange: this.dateRange,
      };

      this.$emit('editCurrentFilter', filterSettings);
    },
    closeModal() {
      this.$emit('closeFilterModal');
    },
  },
};
</script>

<template>
  <div>
    <woot-modal-header
      :header-title="$t('CAMPAIGN.FILTER.MODAL.TITLE')"
      :header-content="$t('CAMPAIGN.FILTER.MODAL.DESCRIPTION')"
      class="mb-4"
    />
    <div
      class="flex flex-col row justify-center content-box pb-6 px-8 my-0 mx-auto"
    >
      <div class="main-container">
        <div class="w-full flex gap-4 flex-col">
          <!-- STATUS FILTER -->
          <div class="pb-2">
            <label>{{ $t('CAMPAIGN.FILTER.STATUS_TOOLTIP') }}</label>
            <div class="multiselect-wrap--small">
              <multiselect
                v-model="selectedStatusFilter"
                class="no-margin text-xxs"
                track-by="id"
                label="label"
                selected-label
                :close-on-select="false"
                :clear-on-select="false"
                hide-selected
                multiple
                :select-label="$t('FORMS.MULTISELECT.ENTER_TO_SELECT')"
                deselect-label=""
                :options="filterStatusList"
                :searchable="false"
                :allow-empty="false"
                :max-height="150"
              />
            </div>
          </div>

          <!-- ORIGIN FILTER -->
          <div class="pb-2">
            <label>{{ $t('CAMPAIGN.FILTER.ORIGIN_TOOLTIP') }}</label>
            <div class="multiselect-wrap--small">
              <multiselect
                v-model="selectedOrganicOrRecurringFilter"
                class="no-margin text-xxs"
                track-by="id"
                label="label"
                selected-label
                :select-label="$t('FORMS.MULTISELECT.ENTER_TO_SELECT')"
                deselect-label=""
                :options="filterOrganicOrRecurringList"
                :searchable="false"
                :allow-empty="false"
                :max-height="150"
              />
            </div>
          </div>

          <!-- DATE RANGE FILTER -->
          <div class="pb-2 w-full">
            <label>{{ $t('CAMPAIGN.FILTER.DATE_RANGE_FILTER') }}</label>
            <DatePicker
              v-model="dateRange"
              range
              format="YYYY-MM-DD"
              class="w-full"
              :confirm-text="$t('CAMPAIGN.ADD.FORM.SCHEDULED_AT.CONFIRM')"
              :placeholder="$t('CAMPAIGN.FILTER.DATE_FILTER_PLACEHOLDER')"
            />
          </div>

          <!-- SAVE FILTERS AND CANCEL MODAL BUTTONS -->
          <div class="flex flex-row justify-end gap-2 pb-1 w-full">
            <woot-button @click="editCurrentFilter">
              {{ $t('CAMPAIGN.FILTER.APPLY_BUTTON') }}
            </woot-button>
            <woot-button variant="clear" @click="closeModal">
              {{ $t('CAMPAIGN.FILTER.CANCEL_BUTTON') }}
            </woot-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
